<!--
 * @Author: jingfei
 * @Date: 2021-08-27 14:10:04
 * @LastEditTime: 2021-09-28 15:31:23
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \common-web\src\components\common\Dialogs\newUploadDialog.vue
-->
<template>
  <el-dialog
    v-dialogDrag
    class="upload-dialog self-dialog-form"
    :title="propData.title || $t('excelConfiguration.import')"
    :visible.sync="dialogVisible"
    :width="width"
    :append-to-body="true"
    :close-on-click-modal="false"
  >
    <div class="upload-top">
      <slot name="top" />
    </div>
    <el-upload
      ref="upload"
      class="upload"
      action
      :on-change="handleChange"
      :show-file-list="false"
      :auto-upload="false"
      accept=".xlsx, .xls"
      :disabled="disabled"
    >
      <el-button class="w100" :disabled="disabled">
        <svg-icon icon-class="upload" />
        <span>{{ $t("excelConfiguration.selectFile") }}</span>
      </el-button>
    </el-upload>
    <div class="description">
      <span class="upload-tip">
        <slot name="tip" />
      </span>
      {{ uploadFileListdescription }}
    </div>
    <div v-show="file" class="upload-file">
      <svg-icon
        v-show="errorData.color === 'error'"
        icon-class="red-exclamation-mark"
        class="icon-shape"
      ></svg-icon>
      <svg-icon
        v-show="errorData.color === 'success' || errorData.color === ''"
        icon-class="file-name-shape"
        class="icon-shape"
      ></svg-icon>
      <div class="file-status">
        <div class="file-name">
          <div :title="file.name" class="text-overflow name">{{ file.name }}</div>
          <div class="operation">
            <i
              v-show="errorData.color === 'error'"
              class="el-icon-refresh-right cursor-p lightText"
              @click="handleRefresh"
            />
            <i
              class="el-icon-close cursor-p lightText"
              style="margin-left: 6px;"
              @click="handleDeleteFile"
            />
          </div>
        </div>
        <div
          class="progress"
          :style="{
            width: `${schedule}%`,
            backgroundColor: errorData.color === 'error' ? '#E60000' : errorData.color === 'success' ? '#00B259' : ''
          }"
        />
      </div>
    </div>

    <div v-show="errorData.isShow" style="margin-top: 10px;" class="upload-file">
      <div class="file-status">
        <div class="file-name">
          <el-tooltip
            class="item"
            effect="dark"
            :content="errorData.messageContent"
            placement="top"
          >
            <div
              class="text-overflow name"
              :style="errorData.color === 'error' ? 'color: #e60000' : 'color: #00b259'"
            >
              {{ errorData.messageContent }}
            </div>
          </el-tooltip>
          <a v-if="errorData.attachmentId" class="error-download-btn" @click="errorDownLoad">下载错误信息</a>
        </div>
      </div>
    </div>
    <div slot="footer">
      <el-button
        @click="
          handleAddRoleShow({
            type: 'down'
          })
        "
      >
        <!-- <svg-icon icon-class="template-download"></svg-icon> -->
        {{ $t("excelConfiguration.downloadTemplate") }}
      </el-button>
      <el-button
        type="primary"
        :disabled="errorData.ButtonState"
        @click="
          handleAddRoleShow({
            type: 'import'
          })
        "
      >
        <!-- <svg-icon icon-class="import-sign"></svg-icon> -->
        {{ $t("excelConfiguration.import") }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "UploadDialog",
  props: {
    visible: {
      type: Boolean,
      default: false
    },

    warnMessage: {
      type: String,
      default: ""
    },

    propData: {
      type: Object,
      default() {
        return {};
      }
    },

    errorData: {
      type: Object,
      default() {
        return {};
      }
    },
    disabled: {
      type: Boolean,
      default() {
        return false;
      }
    },
    width: {
      type: String,
      default: "500px"
    }
  },
  data() {
    return {
      schedule: 100,
      file: "",
      uploadFileListdescription: "已添加0个附件"
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.handleDeleteFile();
        this.errorData.ButtonState = false;
        this.$emit("update:visible", val);
      }
    }
  },
  watch: {
    dialogVisible() {
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles();
      }
    }
  },
  mounted() {
    // this.clearTooltip();
  },
  methods: {
    handleRefresh() {
      this.clearTooltip();
      this.$emit("fileUpload", this.file);
    },

    /**
     * 按钮的操作事件
     * import  导入excel
     * down  下载模板
     */
    handleAddRoleShow(data) {
      if (data.type === "import" && this.file === "") {
        // 请选择excel文件
        this.$message({
          message: "请选择excel文件",
          type: "warning"
        });
      } else if (data.type === "import" && this.file !== "") {
        // 导入excel
        this.$emit("fileUpload", this.file);
      } else if (data.type === "down") {
        // 下载模板
        this.$emit("fileDownload");
      }
    },
    errorDownLoad() {
      this.$emit("errorDownLoad");
    },
    // 获取Excel文档的数据
    handleChange(file) {
      /*
       * if (
       *   file.raw.type !== "application/vnd.ms-excel" &&
       *   file.raw.type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
       * ) {
       *   this.$message.closeAll();
       *   this.$message.warning("只能上传xls、xlsx格式的文件!");
       *   return false;
       * }
       * 重新选择文件，文件名称回显
       */
      this.clearTooltip();
      this.file = file;
      this.uploadFileListdescription = "已添加1个附件";
    },

    handleDeleteFile() {
      this.file = "";
      this.clearTooltip();
      this.uploadFileListdescription = "已添加0个附件";
    },
    // 隐藏数据信息
    clearTooltip() {
      this.errorData.isShow = false;
      this.errorData.color = "";
    }
  }
};
</script>

<style scoped lang="scss">
.upload-dialog {
  .upload {
    width: 100%;
    padding-top: 16px;
  }

  ::v-deep .el-upload--text {
    width: 100%;
  }

  ::v-deep .el-dialog__body {
    padding-bottom: 30px;
  }

  ::v-deep .el-dialog__close {
    color: #505363;
  }

  .description {
    margin: 8px 0 16px 0;
    font-size: 12px;
    line-height: 24px;
    color: #8f9ab3;
  }

  .upload-file {
    display: flex;

    .svg-icon {
      margin-top: 5px;
      margin-right: 8px;
    }

    .file-status {
      flex: 1;
      line-height: 24px;

      .file-name {
        display: flex;
        align-items: center;

        .name {
          max-width: 280px;
        }

        .operation {
          flex: 1;
          text-align: right;
        }

        .error-download-btn {
          min-width: 90px;
          margin-left: 4px;
          color: #00b259;
        }
      }

      .progress {
        height: 2px;
      }
    }
  }
}
</style>
